import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InputRow = ({ children, icon, iconFontSize = '24px', errorMessage = null, sx: sxProp }) => {
    const { t } = useTranslation();

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px',
                    ...sxProp,
                }}
            >
                {/* Fixed-width slot keeps text fields aligned even when iconFontSize varies */}
                <Box
                    sx={{
                        width: '30px',
                        marginRight: '12px',
                        display: 'flex',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    <Box
                        component={FontAwesomeIcon}
                        icon={icon}
                        sx={(theme) => ({
                            fontSize: iconFontSize,
                            color: theme.palette.grey[800],
                        })}
                        fixedWidth
                    />
                </Box>
                <Box sx={{ flexGrow: 1 }}>{children}</Box>
            </Box>
            {errorMessage && (
                <Typography variant="caption" component="div" color="error" sx={{ mt: -0.75, ml: 5.5, mb: 1 }}>
                    {t(errorMessage)}
                </Typography>
            )}
        </>
    );
};

export { InputRow };
